import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import { PV_LAYOUT_TYPE } from 'common/constants';

import { handleCloseDrawer } from '../helpers';

import AttachmentsCard from './AttachmentsCard';
import BomCard from './BomCard';
import DataSheetsCard from './DataSheetsCard';
import DownloadCard from './DownloadCard';
import EditionButtons from './EditionButtons';
import ProposalCard from './ProposalCard';
import PvLayoutCard from './PvLayoutCard';
import SystemsCard from './SystemsCard';

const SupportMenuContent = ({
    attachments,
    boms,
    datasheets,
    downloadFormat,
    editionDisabled,
    handleClickDatasheetItem,
    handleClickDocumentItem,
    handleClickDownload,
    handleClickEditButton,
    handleUpdateTemplate,
    isUpdatingCustomTemplate,
    proposalDetails,
    restorePages,
    selectedDocument,
    setDownloadFormat,
    setEditionDisabled,
    swipeableDrawerRef,
    systems,
}) => {
    const isBomExpress = get(proposalDetails, 'is_bom_express', false);
    const isPvLayoutSelected =
        get(selectedDocument, 'type', null) === PV_LAYOUT_TYPE;

    return (
        <Box>
            <EditionButtons
                editionDisabled={editionDisabled}
                handleClickCancel={() => {
                    restorePages();
                    setEditionDisabled(true);
                    handleCloseDrawer(swipeableDrawerRef);
                }}
                handleClickSave={() => {
                    handleUpdateTemplate();
                    handleCloseDrawer(swipeableDrawerRef);
                }}
                isUpdatingTemplate={isUpdatingCustomTemplate}
                setEditionDisabled={setEditionDisabled}
            />

            <DownloadCard
                documentType={get(selectedDocument, 'type', null)}
                downloadFormat={downloadFormat}
                handleClickDownload={handleClickDownload}
                isDisabled={
                    !editionDisabled ||
                    isUpdatingCustomTemplate ||
                    isPvLayoutSelected
                }
                setDownloadFormat={setDownloadFormat}
            />
            <ProposalCard
                document={proposalDetails}
                handleClickDocumentItem={handleClickDocumentItem}
                handleClickEditButton={handleClickEditButton}
                isDisabled={!editionDisabled || isUpdatingCustomTemplate}
                selectedDocumentId={get(selectedDocument, 'id', null)}
            />

            {!isBomExpress && (
                <PvLayoutCard
                    handleClickDocumentItem={handleClickDocumentItem}
                    isDisabled={!editionDisabled || isUpdatingCustomTemplate}
                    selectedDocument={selectedDocument}
                />
            )}

            <BomCard
                documents={boms}
                handleClickDocumentItem={handleClickDocumentItem}
                handleClickEditButton={handleClickEditButton}
                isDisabled={!editionDisabled || isUpdatingCustomTemplate}
                selectedDocumentId={get(selectedDocument, 'id', null)}
            />
            <SystemsCard
                documents={systems}
                handleClickDocumentItem={handleClickDocumentItem}
                handleClickEditButton={handleClickEditButton}
                isDisabled={!editionDisabled || isUpdatingCustomTemplate}
                selectedDocumentId={get(selectedDocument, 'id', null)}
            />
            <AttachmentsCard
                documents={attachments}
                handleClickDocumentItem={handleClickDocumentItem}
                isDisabled={!editionDisabled || isUpdatingCustomTemplate}
                selectedDocumentId={get(selectedDocument, 'id', null)}
            />
            <DataSheetsCard
                datasheets={datasheets}
                handleClickDocumentItem={handleClickDatasheetItem}
                isDisabled={!editionDisabled || isUpdatingCustomTemplate}
                selectedDocumentId={get(selectedDocument, 'id', null)}
            />
        </Box>
    );
};

SupportMenuContent.propTypes = {
    attachments: PropTypes.array,
    boms: PropTypes.array,
    datasheets: PropTypes.array,
    downloadFormat: PropTypes.number,
    editionDisabled: PropTypes.bool,
    handleClickDatasheetItem: PropTypes.func,
    handleClickDocumentItem: PropTypes.func,
    handleClickDownload: PropTypes.func,
    handleClickEditButton: PropTypes.func,
    handleUpdateTemplate: PropTypes.func,
    isUpdatingCustomTemplate: PropTypes.bool,
    proposalDetails: PropTypes.object,
    restorePages: PropTypes.func,
    selectedDocument: PropTypes.object,
    setDownloadFormat: PropTypes.func,
    setEditionDisabled: PropTypes.func,
    swipeableDrawerRef: PropTypes.object,
    systems: PropTypes.array,
};

export default SupportMenuContent;
